module.exports = __webpack_public_path__ + "img/KV_v8_sign.6f89f8ea.svg";